/* Sparkline.jsx — lightweight SVG line chart, dark theme. No chart library.
 * Props: points [{t, price}], width, height, stroke (optional override).
 * Returns null when there aren't enough points — caller shows the empty state.
 */
import React from "react";

function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return h;
}

export default function Sparkline({ points, width = 560, height = 180, stroke }) {
  const pts = (points || []).filter((p) => p && Number.isFinite(Number(p.price)));
  if (pts.length < 2) return null;
  const prices = pts.map((p) => Number(p.price));
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  const span = max - min || 1;
  const pad = 8;
  const stepX = width / (pts.length - 1);
  const coords = pts.map((p, i) => [
    i * stepX,
    height - pad - ((Number(p.price) - min) / span) * (height - pad * 2),
  ]);
  const line = coords.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const up = prices[prices.length - 1] >= prices[0];
  const color = stroke || (up ? "#3ddc84" : "#ff6b6b");
  const area = `${line} L${width},${height} L0,${height} Z`;
  const gid = `sg${Math.abs(hashStr(line))}`;
  const last = coords[coords.length - 1];
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height}
      preserveAspectRatio="none" role="img" aria-label="Price chart"
      style={{ display: "block" }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.28" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gid})`} />
      <path d={line} fill="none" stroke={color} strokeWidth="2"
        strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      <circle cx={last[0]} cy={last[1]} r="3.5" fill={color} />
    </svg>
  );
}
